import CartItemsOthers from './CartItemsOthers';

export default CartItemsOthers;
